import { message } from 'antd'
import i18next from 'i18next'

export const handleError = (err: any) => {
  console.log(
    'err: ',
    err?.response?.status,
    err?.response ? err?.response?.data : err,
  )
  let errMsg = '',
    errVal
  if (err?.response?.data) {
    const { error, message, value } = err.response.data
    if (error?.length) {
      errMsg = error[0].message
    } else if (message) {
      errMsg = message
    }
    errVal = value
  }

  message.error({ content: i18next.t(errMsg, i18next.t('COMMON_ERROR')) })
}
